import { render, staticRenderFns } from "./tableKontrak.vue?vue&type=template&id=34f298cd&scoped=true"
import script from "./tableKontrak.vue?vue&type=script&lang=js"
export * from "./tableKontrak.vue?vue&type=script&lang=js"
import style0 from "./tableKontrak.vue?vue&type=style&index=0&id=34f298cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f298cd",
  null
  
)

export default component.exports